import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Styles from './styles.js';

var settings = {
  className: 'slider blogsSlider variable-width',
  dots: false,
  infinite: true,

  slidesToShow: 3,
  variableWidth: true,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow iconColor="white" />,
  prevArrow: <SamplePrevArrow iconColor="white" />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        arrows: false,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function SampleNextArrow(props) {
  const { onClick, iconColor } = props;
  return (
    <div className={' slick-arrow right-arrow'} style={{}} onClick={onClick}>
      <svg
        viewBox="0 0 24 24"
        fill={iconColor}
        width="28"
        height="28"
        data-ux="Icon"
        data-edit-interactive="true"
        className="x-el x-el-svg ">
        <path
          fillRule="evenodd"
          d="M7.236 4.195a.773.773 0 0
           1 1.06.031l7.743 7.883-7.742
           7.42a.773.773 0 0 1-1.06 0 .697.697
           0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697 0 0 1 .032-1.016"></path>
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick, iconColor } = props;
  return (
    <div className={' slick-arrow left-arrow'} style={{}} onClick={onClick}>
      <svg
        viewBox="0 0 24 24"
        fill={iconColor}
        width="28"
        height="28"
        data-ux="Icon"
        data-edit-interactive="true"
        className="x-el x-el-svg  ">
        <path
          fillRule="evenodd"
          d="M15.804 19.544a.774.774 0 0
           1-1.061-.03L7 11.63l7.742-7.42a.773.773 0
            0 1 1.061 0 .697.697 0 0 1 0 1.017L9.09
             11.66l6.745 6.867a.698.698 0 0 1-.031 1.016"></path>
      </svg>
    </div>
  );
}

const BlogsSlider = () => {
  const [Blog, setBlog] = useState('');

  useEffect(() => {
    // Update the document title using the browser API
    fetch('https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@soulrooms_inc')
      .then(resp => resp.json())
      .then(blogs => setBlog([blogs.items]));
  }, []);
  const data = Blog[0];

  return (
    <>
      <div className="container mx-auto pt-6 pb-12 px-12 lg:px-0 2xl:px-12">
        <div className="  2xl:px-5">
          <Slider {...settings}>
            {data
              ? data.map((item, index) => (
                  <div className=" " key={index}>
                    <div
                      className="card border-none  lg:pb-6 md:pb-2 pb-4 p-0
               px-0 flex flex-col justify-center items-center
               rounded-0 text-center mx-4 ">
                      <div
                        className="blog3 w-full "
                        style={{
                          background: `linear-gradient(rgba(0, 0, 0, 0.24) 0%, rgba(0, 0, 0, 0.24) 100%)
                       , url(${item.thumbnail})`,
                          backgroundPosition: 'center',
                          backgroundSize: 'cover',
                        }}></div>
                      <div className="flex flex-col md:px-0 px-6 lg:px-4 bg-white">
                        <p
                          className="m-0 pt-2 fs-14-16"
                          style={{
                            fontFamily: 'josefin Sans',
                            color: '#595959',
                          }}>
                          {item.pubDate}
                        </p>
                        <p
                          className="  overflow-hidden pt-0 m-0 lh-27  fs-22-24"
                          style={{
                            height: '109px',
                            fontFamily: 'josefin Sans',
                            color: '#1b1b1b',
                          }}>
                          {item.title}
                        </p>
                        <div
                          className="flex justify-center mb-4
                    items-center md:pt-4 lg:pt-2 pt-3 lg:mt-0">
                          <a
                            href={item.link}
                            target="_blank"
                            rel="noreferrer"
                            className="text-decoration-none  link-warning fs-16-16 "
                            style={{
                              fontFamily: 'josefin Sans',
                              fontSize: '18px',
                              color: '#946F00',
                            }}>
                            Continue Reading
                          </a>
                          <svg
                            viewBox="0 0 24 24"
                            fill="#946F00"
                            width="1em"
                            height="1em"
                            data-ux="Icon"
                            data-aid="chevronRight"
                            className="x-el x-el-svg  link-warning fs-16-16">
                            <path
                              fillRule="evenodd"
                              d="M7.236 4.195a.773.773 0 0 1
                          1.06.031l7.743 7.883-7.742 7.42a.773.773 0
                           0 1-1.06 0 .697.697 0 0 1 0-1.017l6.712-6.433-6.745-6.868a.697.697
                            0 0 1 .032-1.016"></path>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              : null}
          </Slider>
        </div>
      </div>
      <Styles />
    </>
  );
};
export default BlogsSlider;
